import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { environment } from '../../../environments/environment';
import { AuthRefreshService } from '../../service/auth-refresh/auth-refresh.service';

const apiUrl = '/spring/auth/logout';
let serviceCode = '';
serviceCode = environment.serviceCode;

@Injectable()
export class AuthLogoutService {

  constructor(private http: Http, private authRefreshService: AuthRefreshService) { }

  post(): Promise<any> {
    let isRetry = false;
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + apiUrl;

    const headers = new Headers({
      'Content-Type': 'application/json',
      'x-api-key': localStorage.getItem('apiKey'),
      'x-service-code': serviceCode,
      'x-session-key': (JSON.parse(sessionStorage.getItem('loginResult')))['sessionKey'],
      'x-csrf-token': (JSON.parse(sessionStorage.getItem('loginResult')))['csrfToken']
    });

    return this.http.post(url, '{}', { headers: headers }).toPromise()
    .catch(error => {
      if (error.status === 401) {
        isRetry = true;
      } else {
        return Promise.reject(error);
      }
    })
    .then(response => {
      return new Promise((resolve, reject) => {
        if (isRetry === true) {
          // セッションをリフレッシュしAPI呼び出しをリトライ
          this.authRefreshService.execute().toPromise()
          .then(outputJson => {
            headers.set('x-session-key', outputJson['sessionKey']);
            // リトライ
            resolve(this.http.post(url, '{}', { headers: headers }).toPromise()
              .catch((error) => {
                reject(error);
              }));
          })
          .catch((error) => {
            reject(error);
          })
        } else {
          resolve(response);
        }
      });
    });
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/auth-logout/auth-logout.service.ts